// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 959) return "public/css/build/release-cloudweb-15171-133-6-0.202305101522/errorPage.css";
	// return url for filenames based on template
	return undefined;
};